export const REGIONS_EXCEPTION = [
    {country_code: 'RE', country_name: 'Réunion'},
    {country_code: 'MQ', country_name: 'Martinique'},
    {country_code: 'GF', country_name: 'Guyane'},
    {country_code: 'GP', country_name: 'Guadeloupe'},
    {country_code: 'PM', country_name: 'Saint-Pierre-et-Miquelon'},
    {country_code: 'YT', country_name: 'Mayotte'},
    {country_code: 'BL', country_name: 'Saint-Barthélémy'},
    {country_code: 'MF', country_name: 'Saint-Martin'},
    {country_code: 'WF', country_name: 'Wallis-et-Foutouna'},
    {country_code: 'PF', country_name: 'Polynésie Française'},
    {country_code: 'NC', country_name: 'Nouvelle Calédonie'},
    {country_code: 'TF', country_name: 'Terres australes et antarctiques française'},
];